<af-main-container [title]="'i18n_af_incidents' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [buttonLabel]="showCreateButton && ('i18n_af_buttonCreateIncident' | translate)"
                   (buttonClickListener)="navigateToCreateIncident()">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                <ng-template matTabContent>
                    @if (activeTab === tab) {
                    <af-full-table class="w-100 h-100"
                                   [filterFields]="filterFields"
                                   [showImport]="false"
                                   [showExport]="false"
                                   [chips]="chips"
                                   [chipsFormControlName]="chipsFormControlName"
                                   (tableUpdateListener)="loadIncidents($event)"
                                   [dataSource]="dataSource"
                                   [totalElements]="incidentFilterHolderService.getState(activeTab)?.response?.total"
                                   [filterEvent]="incidentFilterHolderService.getState(activeTab)?.tableEvent.filter"
                                   [pageEvent]="incidentFilterHolderService.getState(activeTab)?.tableEvent.page"
                                   [columnTranslationPrefixes]="{id: 'incident', status:'incident'}"
                                   (emptyStateClickListener)="navigateToCreateIncident()"
                                   emptyStateIconName="ic_empty_state_no_data"
                                   emptyStateTitleTranslationKey="i18n_af_emptyStateTitleIncidentsNotCreated"
                                   emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleIncidentsNotCreated"
                                   emptyStateButtonLabel="i18n_af_buttonCreateIncident"
                                   totalElementsTranslationKey="i18n_af_labelTotalElementsIncidents"
                                   placeholderContext="incidents"/>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
